/* ═══════════════════════════════════════════════════════════════
   OrgChartJunctionService — CRUD for the visual junction nodes on
   the org chart. A junction is a small draggable hub that lets one
   line into it spawn many lines out, or vice versa.

   Junctions also act as endpoints in org_chart_edges with sourceType
   /targetType = 'junction'; the *MemberId column holds the junction
   id in that case.
   ═══════════════════════════════════════════════════════════════ */

import * as cache from './cloudCache';
import type { OrgChartJunction } from '../../shared/entities';

export const OrgChartJunctionService = {
  list: async (): Promise<OrgChartJunction[]> =>
    cache.list<OrgChartJunction>('org_chart_junctions'),

  save: async (junction: OrgChartJunction): Promise<OrgChartJunction> =>
    cache.save<OrgChartJunction>('org_chart_junctions', junction),

  delete: async (id: string): Promise<void> => cache.remove('org_chart_junctions', id),
};
